import API from "../../api";
import {
  API_USER_SETTING
} from "../../constants/api";

const getUserSetting = async (category) => {
  try {
    const response = await API.get(API_USER_SETTING, {
      params: {
        category: category
      }
    });
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const updateUserSetting = async (data, category) => {
  try {
    const payload = {
      setting: data,
      category: category
    };
    const headers = {
      'Content-Type': 'application/json'
    };
    const response = await API.post(API_USER_SETTING, JSON.stringify(payload), {headers});
    return response.data;
  } catch (e) {
    throw e.response
  }
};

const UserSetting = {
  getUserSetting,
  updateUserSetting
};

export {
  UserSetting as default,
  getUserSetting,
  updateUserSetting
}